export enum TransferMonitoringPermissions {
  DashBoard = 'dashboard',
  MonitoringMboCheckSoftYear = 'monitoring.check-mbo-soft-check',
  MonitoringInt1SubExport = 'monitoring.sub-export',
  MonitoringMboCheckYearOverview = 'monitoring.mbo-check-year',
  MonitoringProgressVmbo = 'monitoring.progress-vmbo',
  MonitoringProgressMbo = 'monitoring.progress-mbo',
}
